import { Injectable } from '@angular/core';

/**
 * Stub LoggerService to replace @wdpr/ra-angular-logger which is not Ivy-compatible.
 * TODO: Replace with updated @wdpr/ra-angular-logger when Angular 20-compatible version is available.
 */
@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  error(...args: unknown[]): void {
    console.error('[LoggerService]', ...args);
  }

  warn(...args: unknown[]): void {
    console.warn('[LoggerService]', ...args);
  }

  log(...args: unknown[]): void {
    console.log('[LoggerService]', ...args);
  }

  debug(...args: unknown[]): void {
    console.debug('[LoggerService]', ...args);
  }
}
